import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { StorageService } from '../storage/storage.service';

export interface IStorageWallet
{
    crypto_wallet: string;
    address: string;
    platform: string;
    hd_path?: string;
    account_index?: number;
    id?: number;
    platformDb?: { id: number, name: string; };
    name: string;
    hidden?: boolean;
    balance_off?: boolean;
    order_index?: number;
    collapsed?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class WalletsApi
{

    constructor(
        private storage: StorageService,
        private http: HttpClient
    ) { }

    public async getWallets(cryptoWalletId: string): Promise<IStorageWallet[]>
    {
        try
        {
            const url = `/api/wallet/list/${ cryptoWalletId }`;
            return await this.http.get<IStorageWallet[]>(url).toPromise();
        }
        catch (error)
        {
            console.error(error);
            return [];
        }

        // const wallets: IStorageWallet[] = await this.storage.getOption('wallets').toPromise();
        //
        // return Array.isArray(wallets) ? wallets.filter(({ crypto_wallet }) => crypto_wallet === _cryptoWalletId) : [];
    }

    public async getWalletsOnce(id: string): Promise<any | null>
    {
        try
        {
            const url = `/api/wallet/${ id }`;
            return await this.http.get<any>(url).toPromise();
        }
        catch (error)
        {
            console.error(error);
            return null;
        }
    }

    public async getWalletsAll(): Promise<any[]>
    {
        try
        {
            const url = '/api/wallet/all';
            return await this.http.get<any[]>(url).toPromise();
        }
        catch (error)
        {
            console.error(error);
            return [];
        }
    }

    public async updateWalletsOrder(dataOrders: any[]): Promise<void>
    {
        try
        {
            const url = '/api/wallet/update-order';
            await this.http.patch(url, dataOrders).toPromise();
        } catch (e)
        {
            console.error(e);
        }
    }

    public async updateBalance(dataBalance: any): Promise<void>
    {
        try
        {
            const url = '/api/wallet/update-balance-off';
            await this.http.patch(url, dataBalance).toPromise();
        } catch (e)
        {
            console.error(e);
        }
    }

    public async updateHidden(dataHidden: any): Promise<void>
    {
        try
        {
            const url = '/api/wallet/update-hidden';
            await this.http.patch(url, dataHidden).toPromise();
        } catch (e)
        {
            console.error(e);
        }
    }

    public async updateWallet(data: any): Promise<void>
    {
        const url = `/api/wallet/${ data.id }`;
        await this.http.patch(url, data).toPromise();
    }

    public async updateCollapsed(data: any): Promise<void>
    {
        try
        {
            const url = `/api/wallet/update-collapsed`;
            await this.http.patch(url, data).toPromise();
        } catch (e)
        {
            console.error(e);
        }
    }

    public async setWallet(wallet: IStorageWallet): Promise<IStorageWallet>
    {
        return await this.http.post<IStorageWallet>(`/api/wallet`, {
            cryptoWalletId: wallet.crypto_wallet,
            address: wallet.address,
            platform: wallet.platform,
            hd_path: wallet.hd_path,
            acc_index: wallet.account_index,
            name: wallet.name,
            orderIndex: wallet.order_index || 0,
        }).toPromise();

        // let wallets: IStorageWallet[] = (await this.storage.getOption('wallets').toPromise()) || [];
        //
        // wallets = wallets.filter(wallet => wallet.address !== _wallet.address && wallet.crypto_wallet !== _wallet.crypto_wallet);
        //
        // wallets  = [...wallets, _wallet];
        //
        // return this.storage.setOption('wallets', wallets);
    }

    public async deleteWallet(walletID: string): Promise<void>
    {
        try
        {
            const url = `/api/wallet/${ walletID }`;
            await this.http.delete<any>(url).toPromise();
        }
        catch (error)
        {
            console.error(error);
        }
    }
}
